import angular from 'angular';
import ImageCategoryListComponent from './components/category_listing';
import ImageCategoryAddComponent from './components/category_add';
import ImageCategoryEditComponent from './components/category_edit';
import ImageListComponent from './components/list';
import ImageAddComponent from './components/add';
import ImageEditComponent from './components/edit';
import {ImagesConfig} from './components/images.config';
import uiRouter from 'angular-ui-router';
import ngFileUpload from 'ng-file-upload';
import ImagesService from './services/images.service';
import ImagesDataProvider from './services/images.dataprovider.service';

export default angular.module('images', [uiRouter, ngFileUpload])
  .component('imageCategoryList', ImageCategoryListComponent)
  .component('imageCategoryAdd', ImageCategoryAddComponent)
  .component('imageCategoryEdit', ImageCategoryEditComponent)
  .component('imageList', ImageListComponent)
  .component('imageAdd', ImageAddComponent)
  .component('imageEdit', ImageEditComponent)
  .service('Images', ImagesService)
  .service('ImagesDataProvider', ImagesDataProvider)
  .config(ImagesConfig)
  .name


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/images/index.js
 **/